import React from "react"

class NumberInput extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({value: nextProps.value});
    }
  }

  render() {
    return (
      <input type="number" {...this.props} value={this.state.value || this.state.value == 0 ? this.state.value : ''} onBlur={this.onBlur} onChange={this.onChange} className={this.props.className} style={this.props.custom_style ? this.props.custom_style : null} />
    );
  }

  onBlur(event) {
    var value = this.processValue(event.target.value);

    if (value != this.state.value) {
      this.setState({value: value}, () => {
        this.onChange({target: {value: value}});
      });
    }
  }

  onChange(event) {
    var value = this.processValue(event.target.value);

    if (value != this.state.value || (value == 0 && typeof this.state.value != "number")) {
      this.setState({value: value}, () => {
        if (typeof this.props.onChange == 'function') {
          this.props.onChange({target: {name: this.props.name, value: this.state.value}});
        }
      });
    }
  }

  processValue(val) {
    var value = parseFloat(val, 10);

    if (isNaN(value)) {
      value = null;
    } else if (typeof this.props.min == 'number' && value < this.props.min) {
      value = this.props.min;
    } else if (typeof this.props.max == 'number' && value > this.props.max) {
      value = this.props.max;
    }

    return value;
  }

};

export default NumberInput
